var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPersonRound = function SvgPersonRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.529 12.536a3.826 3.826 0 1 0-2.943-7.065 3.826 3.826 0 0 0 2.943 7.065Z",
    fill: "#DE6AEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.049 14.088C9.172 14.088 6 17.26 6 21.138 6 22.143 6.806 23 7.863 23h10.422a1.859 1.859 0 0 0 1.863-1.863c-.05-3.877-3.172-7.049-7.1-7.049Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 23C18.299 23 23 18.299 23 12.5S18.299 2 12.5 2 2 6.701 2 12.5 6.701 23 12.5 23Zm0 2C19.404 25 25 19.404 25 12.5S19.404 0 12.5 0 0 5.596 0 12.5 5.596 25 12.5 25Z"
  })));
};

export default SvgPersonRound;